module.exports = { "default": require("core-js/library/fn/object/assign"), __esModule: true };


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/~/babel-runtime/core-js/object/assign.js
// module id = ../../../../babel-runtime/core-js/object/assign.js
// module chunks = 42